export const darkTheme = {
  "lm-bg": "#141D2F",
  "lm-bg-content": "#1E2A47",
  "lm-text": "white",
  "lm-text-alt": "white",
  "lm-shadow-active": "0px 4px 4px 0px rgba(0,0,0,0.25)",
  "lm-shadow-inactive": "0px 16px 30px -10px rgba(0,0,0,0.2)",
  "lm-icon-bg": "brightness(100%)",
  btn: "#0079FF",
  "btn-hover": "#60ABFF",
};

export const lightTheme = {
  "lm-bg": "#F6F8FF",
  "lm-bg-content": "#FEFEFE",
  "lm-text": "#4B6A9B",
  "lm-text-alt": "#2B3442",
  "lm-shadow-active": "0px 4px 4px 0px rgba(0,0,0,0.25)",
  "lm-shadow-inactive": "0px 16px 30px -10px rgba(0,0,0,0.2)",
  "lm-icon-bg": "brightness(100%)",
  btn: "#0079FF",
  "btn-hover": "#60ABFF",
};
